<template>
  <div class="carousel-navigation">
    <button
      class="carousel-navigation-button carousel-navigation-prev"
      :class="{ 'carousel-navigation-prev--disabled': prevDisabled }"
      @click.prevent="triggerPageAdvance('backward')"
    >
      <svg class="icon icon-arrow-left" style="fill: rgb(4 110 196)">
        <use xlink:href="#arrow-left"></use>
      </svg>
      <span class="is-sr-only">{{ previousSlideText }}</span>
    </button>
    <button
      class="carousel-navigation-button carousel-navigation-next"
      :class="{ 'carousel-navigation-next--disabled': nextDisabled }"
      @click.prevent="triggerPageAdvance('forward')"
    >
      <svg class="icon icon-arrow-right" style="fill: rgb(4 110 196)">
        <use xlink:href="#arrow-right"></use>
      </svg>
      <span class="is-sr-only">{{ nextSlideText }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'navigation',
  props: {
    prevDisabled: {
      type: Boolean,
      default: false,
    },
    nextDisabled: {
      type: Boolean,
      default: false,
    },
    previousSlideText: {
      type: String,
      required: true,
    },
    nextSlideText: {
      type: String,
      required: true,
    },
  },
  methods: {
    triggerPageAdvance(direction) {
      this.$emit('page-advance-click', direction);
    },
  },
};
</script>
